import React, { useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import RichText from '../../../components/RichEditor/RichText'
import { compare } from './diff_compare_object'
import TableComponent from '../../../components/Common/TableComponent'
import uuid from 'uuid'

const DiffTableBoardReport = props => {
  const { type, dataBefore, dataAfter, fileMap = {} } = props

  const [diffList, setDiffList] = useState([])
  const fieldNameMap = {
    attachments: 'Tài liệu đính kèm',
    title: 'Tiêu đề',
    content: 'Nội dung',
  }

  const persistentFileMap = useMemo(() => {
    const stored = localStorage.getItem('persistentFileMap')
    let existing = {}
    try {
      existing = stored ? JSON.parse(stored) : {}
    } catch (e) {
      console.warn('Error parsing persistentFileMap from localStorage:', e)
    }

    const updated = { ...existing, ...fileMap }

    localStorage.setItem('persistentFileMap', JSON.stringify(updated))

    return updated
  }, [fileMap])

  useEffect(() => {
    let before = {}
    let after = {}

    try {
      before = JSON.parse(dataBefore || '{}') || {}
    } catch (e) {
      console.warn('Invalid dataBefore JSON:', dataBefore)
    }

    try {
      after = JSON.parse(dataAfter || '{}') || {}
    } catch (e) {
      console.warn('Invalid dataAfter JSON:', dataAfter)
    }

    let result = compare(type, before, after)

    if (!result || result.length === 0) {
      const fields = new Set([...Object.keys(before), ...Object.keys(after)])
      result = [...fields]
        .map(field => {
          const fieldValueBefore = before[field]
          const fieldValueAfter = after[field]

          const normalize = value => {
            if (value === null || value === undefined) return ''
            if (Array.isArray(value)) return value.join(', ')
            return value
          }

          if (
            JSON.stringify(fieldValueBefore) !== JSON.stringify(fieldValueAfter)
          ) {
            if (field === 'attachments') {
              const beforeList = fieldValueBefore || []
              const afterList = fieldValueAfter || []

              const mapFileName = id => {
                if (persistentFileMap[id]) {
                  return persistentFileMap[id]
                }
                return id
              }

              const afterSet = new Set(afterList)
              const beforeSet = new Set(beforeList)

              const allIds = [...beforeList]
              afterList.forEach(id => {
                if (!beforeSet.has(id)) {
                  allIds.push(id)
                }
              })

              const beforeHtml = allIds
                .filter(id => beforeSet.has(id))
                .map(id => {
                  const fileName = mapFileName(id)
                  return `<div>• ${fileName}</div>`
                })
                .join('')

              const afterHtml = allIds
                .map(id => {
                  const fileName = mapFileName(id)
                  const isAdded = !beforeSet.has(id)
                  const isRemoved = !afterSet.has(id)

                  if (isRemoved) {
                    return `<div>• <span style="color:red;text-decoration:line-through;">${fileName}</span></div>`
                  }

                  if (isAdded) {
                    return `<div>• <span style="color:blue;">${fileName}</span></div>`
                  }

                  return `<div>• ${fileName}</div>`
                })
                .join('')

              return {
                field,
                fieldValueBefore: beforeHtml,
                fieldValueAfter: afterHtml,
              }
            }

            return {
              field,
              fieldValueBefore: normalize(fieldValueBefore),
              fieldValueAfter: normalize(fieldValueAfter),
            }
          }

          return null
        })
        .filter(Boolean)
    }

    setDiffList(result)
  }, [dataBefore, dataAfter, type, persistentFileMap])

  const columns = [
    {
      title: 'Trường dữ liệu',
      width: 150,
      render: record => (
        <RichText htmlText={fieldNameMap[record.field] || record.field} />
      ),
    },
    {
      title: 'Trước thay đổi',
      width: 300,
      render: record => (
        <RichText htmlText={record.fieldValueBefore}></RichText>
      ),
    },
    {
      title: 'Sau thay đổi',
      width: 300,
      render: record => <RichText htmlText={record.fieldValueAfter}></RichText>,
    },
  ]

  return (
    <div>
      <TableComponent
        rowKey={() => uuid()}
        dataSource={diffList}
        columns={columns}
        pagination={false}
      />
    </div>
  )
}

DiffTableBoardReport.propTypes = {
  dataBefore: PropTypes.string,
  dataAfter: PropTypes.string,
  type: PropTypes.string,
  fileMap: PropTypes.object,
}

export default DiffTableBoardReport
